<template>
  <Badge
    v-bind="$attrs"
    :variant="props.variant ?? 'text'"
    :value="resolvedValue"
    :size="resolvedSize"
    :aria-label="props.ariaLabel"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { Badge } from '@p-utilities/vue'
import type { BadgeVariant, BadgeDotSize } from '@p-utilities/vue'

const props = defineProps<{
  // DS-native passthrough
  variant?: BadgeVariant
  value?: string | number
  size?: BadgeDotSize | 'sm' | 'md' | 'lg'
  ariaLabel?: string

  // Legacy aliases (preserved for existing call sites)
  text?: string | number
  // `color` is accepted for backward-compat but silently ignored — DS Badge
  // is single-color (brand). Existing call sites only use color="success",
  // which matches DS default.
  color?: 'success' | 'danger'
}>()

const resolvedValue = computed<string | number | undefined>(() => props.value ?? props.text)

const SIZE_MAP: Record<string, BadgeDotSize> = {
  sm: 'small',
  md: 'medium',
  lg: 'large',
}
const resolvedSize = computed<BadgeDotSize>(() => {
  const s = props.size
  if (!s) return 'small'
  if (s === 'small' || s === 'medium' || s === 'large') return s
  return SIZE_MAP[s] ?? 'small'
})
</script>
